export default __webpack_public_path__ + "static/chrysa-7c41ad8bf21c9050635008c065a8426b.jpg";